/* eslint-disable */
import config from '../../config'
import { Link } from 'react-router-dom'
import { useEffect, useState, useContext, useLayoutEffect } from 'react'
import {
  BreadcrumbArrow,
  SearchIcon,
  LangArrows,
  RightArrow,
} from '../../icons'
import Useful from '../../components/pages/useful'
import styles from './index.module.scss'
import text from './text.json'
import { EventCard } from '../../components/core/cards'
import Subscribe from '../../components/pages/subscribe'
import { PageContext } from '../../context/PageContextProvider'
import PagesAPI from '../../api/pages'
import NewsAPI from '../../api/news'
import Loading from '../../components/pages/loading'
import translate from '../../utils/translate.json'
import img from '../../assets/images/news.jpg'

const Telim = ({ className }) => {
  const { language } = useContext(PageContext)
  const [filter, setFilter] = useState(translate.sort?.[language] || '')
  const [category, setCategory] = useState(translate.category?.[language] || '')
  const [data, setData] = useState([])
  const [subcategory, setSubcategory] = useState(
    translate.subcategory?.[language] || '',
  )
  const [isVisible1, setIsVisible1] = useState(false)
  const [isVisible3, setIsVisible3] = useState(false)
  const [isVisible4, setIsVisible4] = useState(false)
  const [current, setCurrent] = useState(1)
  let len = 23
  const [width, setWidth] = useState(false)
  useLayoutEffect(() => {
    function updateSize() {
      if (window.innerWidth <= 768) {
        setWidth(true)
        return
      }
      setWidth(false)
    }

    window.addEventListener('resize', updateSize)
    updateSize()
  }, [])
  const selects = [
    {
      current: filter,
      menu: ['Oldest to newest', 'newest to oldest'],
    },
    {
      current: category,
      menu: ['category1', 'category2', 'category3'],
    },
    {
      current: subcategory,
      menu: ['Subcategory1', 'Subcategory2', 'Subcategory3'],
    },
  ]
  const button = {
    AZ: 'Bizə özünüz haqda deyin',
    ENG: 'Tell us about yourself',
    RU: 'Расскажите нам о себе',
  }
  const [load, setLoad] = useState(false)
  const [info, setInfo] = useState([])
  useEffect(() => {
    (async () => {

    const data1 = await PagesAPI.getMagazinePageInfo()
    const data2 = await NewsAPI.getAllTelim()
    await setInfo(data1.data)
    await setData(data2.data)
    await setLoad(true)
  
    })();
  }, [])
  return load ? (
    <section className={className}>
      <Useful search={false} />

      <div className={styles.container}>
        {/* <div className={styles.selects}>
          <div
            className={styles.select}
            onBlur={() =>
              setTimeout(function () {
                setIsVisible1(false)
              }, 250)
            }
          >
            <span tabIndex="1" onClick={() => setIsVisible1(true)}>
              {selects[0].current} <LangArrows />
            </span>
            <ul style={isVisible1 ? { display: 'block' } : { display: 'none' }}>
              {selects[0].menu.map((e) => (
                <li
                  onClick={() => {
                    setFilter(e)
                  }}
                >
                  {e}
                </li>
              ))}
            </ul>
          </div>
          <div
            className={styles.select}
            onBlur={() =>
              setTimeout(function () {
                setIsVisible3(false)
              }, 250)
            }
          >
            <span tabIndex="1" onClick={() => setIsVisible3(true)}>
              {selects[1].current} <LangArrows />
            </span>
            <ul style={isVisible3 ? { display: 'block' } : { display: 'none' }}>
              {selects[1].menu.map((e) => (
                <li
                  onClick={() => {
                    setCategory(e)
                  }}
                >
                  {e}
                </li>
              ))}
            </ul>
          </div>
          <div
            className={styles.select}
            onBlur={() =>
              setTimeout(function () {
                setIsVisible4(false)
              }, 250)
            }
          >
            <span tabIndex="1" onClick={() => setIsVisible4(true)}>
              {selects[2].current} <LangArrows />
            </span>
            <ul style={isVisible4 ? { display: 'block' } : { display: 'none' }}>
              {selects[2].menu.map((e) => (
                <li
                  onClick={() => {
                    setSubcategory(e)
                  }}
                >
                  {e}
                </li>
              ))}
            </ul>
          </div>
        </div> */}
        <div className={styles.content}>
          {data.map((item) => (
            <EventCard
              img={
                item.photoLocation
                  ? item.photoLocation.startsWith('http')
                    ? item.photoLocation
                    : `${config.API_URL}${item.photoLocation.startsWith('/') ? '' : '/'}${item.photoLocation}`
                  : img
              }
              title={item.title[language]}
              date={new Date(item.date).toLocaleDateString()}
              event={item.newsType}
              label={item.isActive}
              to={`/news/${item._id}`}
            />
          ))}
        </div>
        {/* {width ? (
          <div className={styles.pagination}>
            {current === 1 ? (
              <button style={{ cursor: 'not-allowed', opacity: 0.6 }}>
                <RightArrow /> Prev
              </button>
            ) : (
              <button
                onClick={() => {
                  setCurrent(current - 1)
                }}
              >
                <RightArrow /> Prev
              </button>
            )}
            <div>
              {current >= len - 4 ? (
                <span
                  onClick={() => {
                    setCurrent(len - 4)
                  }}
                  style={
                    current === len - 4
                      ? { backgroundColor: '#0095FF', color: 'white' }
                      : null
                  }
                >
                  {len - 4}
                </span>
              ) : (
                <span
                  onClick={() => {
                    setCurrent(current)
                  }}
                >
                  {current}
                </span>
              )}
              {current >= len - 4 ? (
                <span
                  onClick={() => {
                    setCurrent(len - 3)
                  }}
                  style={
                    current === len - 3
                      ? { backgroundColor: '#0095FF', color: 'white' }
                      : null
                  }
                >
                  {len - 3}
                </span>
              ) : (
                <span
                  onClick={() => {
                    setCurrent(current + 1)
                  }}
                >
                  {current + 1}
                </span>
              )}
              {current >= len - 4 ? (
                <span
                  onClick={() => {
                    setCurrent(len - 2)
                  }}
                  style={
                    current === len - 2
                      ? { backgroundColor: '#0095FF', color: 'white' }
                      : null
                  }
                >
                  {len - 2}
                </span>
              ) : (
                <span
                  onClick={() => {
                    setCurrent(current + 2)
                  }}
                >
                  {current + 2}
                </span>
              )}
              {current >= len - 4 ? (
                <span
                  onClick={() => {
                    setCurrent(len - 1)
                  }}
                  style={
                    current === len - 1
                      ? { backgroundColor: '#0095FF', color: 'white' }
                      : null
                  }
                >
                  {len - 1}
                </span>
              ) : (
                <div>{'...'}</div>
              )}
              {current >= len - 4 ? (
                <span
                  onClick={() => {
                    setCurrent(len)
                  }}
                  style={
                    current === len
                      ? { backgroundColor: '#0095FF', color: 'white' }
                      : null
                  }
                >
                  {len}
                </span>
              ) : (
                <span
                  onClick={() => {
                    setCurrent(len)
                  }}
                >
                  {len}
                </span>
              )}
            </div>
            {current === len ? (
              <button style={{ cursor: 'not-allowed', opacity: 0.6 }}>
                {translate.next[language]} <RightArrow />
              </button>
            ) : (
              <button
                onClick={() => {
                  setCurrent(current + 1)
                }}
              >
                {translate.next[language]} <RightArrow />
              </button>
            )}
          </div>
        ) : (
          <div className={styles.pagination}>
            {current === 1 ? (
              <button style={{ cursor: 'not-allowed', opacity: 0.6 }}>
                <RightArrow /> {translate.previous[language]}
              </button>
            ) : (
              <button
                onClick={() => {
                  setCurrent(current - 1)
                }}
              >
                <RightArrow /> {translate.previous[language]}
              </button>
            )}
            <div>
              {current >= len - 6 ? (
                <span
                  onClick={() => {
                    setCurrent(len - 6)
                  }}
                  style={
                    current === len - 6
                      ? { backgroundColor: '#0095FF', color: 'white' }
                      : null
                  }
                >
                  {len - 6}
                </span>
              ) : (
                <span
                  onClick={() => {
                    setCurrent(current)
                  }}
                  style={{ backgroundColor: '#0095FF', color: 'white' }}
                >
                  {current}
                </span>
              )}
              {current >= len - 6 ? (
                <span
                  onClick={() => {
                    setCurrent(len - 5)
                  }}
                  style={
                    current === len - 5
                      ? { backgroundColor: '#0095FF', color: 'white' }
                      : null
                  }
                >
                  {len - 5}
                </span>
              ) : (
                <span
                  onClick={() => {
                    setCurrent(current + 1)
                  }}
                >
                  {current + 1}
                </span>
              )}
              {current >= len - 6 ? (
                <span
                  onClick={() => {
                    setCurrent(len - 4)
                  }}
                  style={
                    current === len - 4
                      ? { backgroundColor: '#0095FF', color: 'white' }
                      : null
                  }
                >
                  {len - 4}
                </span>
              ) : (
                <span
                  onClick={() => {
                    setCurrent(current + 2)
                  }}
                >
                  {current + 2}
                </span>
              )}
              {current >= len - 6 ? (
                <span
                  onClick={() => {
                    setCurrent(len - 3)
                  }}
                  style={
                    current === len - 3
                      ? { backgroundColor: '#0095FF', color: 'white' }
                      : null
                  }
                >
                  {len - 3}
                </span>
              ) : (
                <span
                  onClick={() => {
                    setCurrent(current + 3)
                  }}
                >
                  {current + 3}
                </span>
              )}
              {current >= len - 6 ? (
                <span
                  onClick={() => {
                    setCurrent(len - 2)
                  }}
                  style={
                    current === len - 2
                      ? { backgroundColor: '#0095FF', color: 'white' }
                      : null
                  }
                >
                  {len - 2}
                </span>
              ) : (
                <span
                  onClick={() => {
                    setCurrent(current + 4)
                  }}
                >
                  {current + 4}
                </span>
              )}
              {current >= len - 6 ? (
                <span
                  onClick={() => {
                    setCurrent(len - 1)
                  }}
                  style={
                    current === len - 1
                      ? { backgroundColor: '#0095FF', color: 'white' }
                      : null
                  }
                >
                  {len - 1}
                </span>
              ) : (
                <div>{'...'}</div>
              )}
              {current >= len - 6 ? (
                <span
                  onClick={() => {
                    setCurrent(len)
                  }}
                  style={
                    current === len
                      ? { backgroundColor: '#0095FF', color: 'white' }
                      : null
                  }
                >
                  {len}
                </span>
              ) : (
                <span
                  onClick={() => {
                    setCurrent(len)
                  }}
                >
                  {len}
                </span>
              )}
            </div>
            {current === len ? (
              <button style={{ cursor: 'not-allowed', opacity: 0.6 }}>
                {translate.next[language]} <RightArrow />
              </button>
            ) : (
              <button
                onClick={() => {
                  setCurrent(current + 1)
                }}
              >
                {translate.next[language]} <RightArrow />
              </button>
            )}
          </div>
        )} */}
      </div>
    </section>
  ) : (
    <Loading />
  )
}
export default Telim
